import React, {useEffect, useState} from "react";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import {formatConfirmationCode} from '../../utils/index';
import {Formik} from 'formik';
import Alert from "@material-ui/lab/Alert";
import {
    setLoadingSpinnerOpen,
} from '../../actions/loadingSpinner';
import {
    confirmSocialLoginAccount,
    resendConfirmationCodeForSocialLogin,
    idpLogin, confirmSocialLoginAccountReset
} from "../../actions/security";
import loadable from "../../components/Lazy";
import {useParams} from "react-router-dom";
import RecaptchaProtectionMessage from "../RecaptchaProtectionMessage";
import SocialLoginButton from "../SocialLoginButton";
import IconButton from "../Button/IconButton";

const Recaptcha = loadable(() => import('../../components/App/Recaptcha'));

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '480px',
        margin: '50px auto'
    },
}));

const SocialLoginConfirmCodeRoute = ({
    confirmSocialLoginAccount,
    userData,
    setLoadingSpinnerOpen,
    resendConfirmationCodeForSocialLogin,
    idpLogin,
    confirmSocialLoginAccountSuccess,
}) => {
    const classes = useStyles();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { mobile } = useParams();
    const queryParams = new URLSearchParams(window.location.search);
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const [willLogin, setWillLogin] = useState(false);


    const handleResendConfirmationCode = () => {
        setLoadingSpinnerOpen(true);
        resendConfirmationCodeForSocialLogin({
            phone: userData.mobile
        });
    }

    const handleSubmit = (values) => {
        confirmSocialLoginAccount({
            verificationCode: values.verificationCode.replace(/\D/, ''),
            mobile: `1${mobile.replace(/^1|\D/g, '')}`,
            idpToken: userData.idp_token,
            name: userData.name,
            surname: userData.surname,
            email: userData.email,
        });
    };


    useEffect(() => {
        if (confirmSocialLoginAccountSuccess) {
            // sign the user in using social
            setWillLogin(true);
            confirmSocialLoginAccountReset();
        }
    }, [confirmSocialLoginAccountSuccess, setLoadingSpinnerOpen]);

    return (
        <Container>
            <div className={classes.root}>
                <Formik
                    enableReinitialize={true}
                    validateOnMount={true}
                    initialValues={{
                        verificationCode: ''
                    }}
                    validate={(values) => {
                        const errors = {
                            ...(!/^[0-9]{3}-[0-9]{3}$/gim.test(values.verificationCode) && {verificationCode: 'Please enter a valid confirmation code'}),
                        };
                        if (Object.keys(errors).length > 0) {
                            setIsSubmitting(false);
                        }
                        return errors;
                    }}
                    onSubmit={handleSubmit}>
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        submitForm,
                        isValid,
                        dirty
                    }) => {

                        const handleRecaptchaSubmit = (recaptchaToken) => {
                            setRecaptchaToken(recaptchaToken);
                            setIsSubmitting(true)
                            submitForm();
                        };
                        return (
                            // <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h2" component="h1" align="center" gutterBottom={true}>Verify Phone number</Typography>
                                </Grid>

                                {queryParams.get('msg') === 'resend-success' && (
                                    <Grid item xs={12}>
                                        <Alert severity="success">A new verification code was sent. Please check your device</Alert>
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <TextField
                                        onChange={(e) => {
                                            const value = e.target.value || "";
                                            setFieldValue('verificationCode', formatConfirmationCode(value));
                                        }}
                                        fullWidth={true}
                                        label="Confirmation Code"
                                        variant="filled"
                                        color="primary"
                                        name="verificationCode"
                                        value={values.verificationCode}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Recaptcha
                                        onSubmit={handleRecaptchaSubmit}
                                    >
                                        {({submitAction}) => {
                                            const handleClick = (e) => {
                                                setLoadingSpinnerOpen(true);
                                                submitAction(e);
                                            }
                                            return (
                                                <Button
                                                    loading={isSubmitting}
                                                    onClick={handleClick}
                                                    disabled={!isValid || isSubmitting}
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Confirm
                                                </Button>
                                            );
                                        }}
                                    </Recaptcha>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button color="secondary" fullWidth={true} onClick={handleResendConfirmationCode}>Resend confirmation code</Button>
                                </Grid>

                                <Grid item xs={12} style={{marginBottom: '80px', marginTop: '100px', marginLeft: 'auto', marginRight: 'auto', maxWidth: '400px'}}>
                                    <RecaptchaProtectionMessage />
                                </Grid>


                                <Grid item>
                                    <div style={{visibility: 'hidden', position: 'absolute'}}>

                                        {willLogin && userData.idp_service === 'google' && (
                                            <SocialLoginButton
                                                idpService="google"
                                                loginCallback={idpLogin}
                                                Component={IconButton}
                                                ComponentProps={{}}
                                                forceClickRecaptcha={recaptchaToken}
                                            >
                                                <img src="https://res.cloudinary.com/giftya-llc/image/upload/v1670012516/Design%20Assets/Icons/Google_-_Original_cnbkpz.svg" alt="" />
                                            </SocialLoginButton>
                                        )}
                                        {willLogin && userData.idp_service === 'facebook' && (
                                            <SocialLoginButton
                                                idpService="facebook"
                                                loginCallback={idpLogin}
                                                Component={IconButton}
                                                ComponentProps={{}}
                                                forceClickRecaptcha={recaptchaToken}
                                            >
                                                <img src="https://res.cloudinary.com/giftya-llc/image/upload/v1670012610/Design%20Assets/Icons/Facebook_-_Original_outyaa.svg" alt="" />
                                            </SocialLoginButton>
                                        )}

                                    </div>
                                </Grid>


                            </Grid>
                            // </form>
                        )}}
                </Formik>
            </div>
        </Container>
    )
}

export default connect(
    (state) => ({
        confirmSocialLoginAccountSuccess: state.security.confirmSocialLoginAccountSuccess,
    }),
    {
        resendConfirmationCodeForSocialLogin,
        confirmSocialLoginAccount,
        setLoadingSpinnerOpen,
        idpLogin
    }
)(SocialLoginConfirmCodeRoute);